module.exports = __webpack_public_path__ + "img/1570902818.cbcb32b6.jpg";